export default {
  header: ["Name", "Type", "Values"],
  body: [["gap", "String", ["xs", "sm", "md", "lg", "xl"]]]
};
